const expandChildren = 'p';
export default async element => { // 'comp-faq dl > dt'
	let children = element.querySelectorAll(expandChildren);
	element.classList.add('loaded');
	if(children.length > 0){
		element.setAttribute('items',children.length);
	}
	element.addEventListener('click', () => toggleElement(element,!element.hasAttribute('toggled')));
};

function toggleElement(element,on){
	[...element.parentNode.getElementsByTagName(element.tagName)].forEach((sibling)=>{
		if(sibling !== element) sibling.removeAttribute('toggled');
	});
	element[on ? 'setAttribute' : 'removeAttribute']('toggled','toggled');
}